import { ICardNumberStatusChangeAction } from './types';
import { AT_STATUS_CHANGE } from './constants';
import { ECardNumberStatus } from '../types';

export const statusChange = (status: ECardNumberStatus): ICardNumberStatusChangeAction => ({
    type: AT_STATUS_CHANGE,
    status
})
